<template>
  <div class="card modal-card-validation modal-card-border card-validation">
    <div class="card-content">
      <MsgError
        v-if="msgErrors.length"
        class="mt-20"
        type="is-danger"
        :msgs="msgErrors"
        :autoClose="false"
        @close="$emit('clear-errors')"/>
      <section>
        <p class="subtitle is-4 has-text-centered has-text-weight-bold">
          {{$t('recapRecom.libelleValiderDef')}}
        </p>
        <p class="is-size-14px has-text-centered">
          {{$t('recapRecom.messageModal')}}
        </p>
      </section>
      <br>
      <footer>
        <div class="mt-20">
          <b-button class="no-border-button has-text-centered"
            @click="$emit('close')">
            {{$t('envoiMail.btnAnnuler')}}
          </b-button>
          <b-button class="is-primary has-text-centered ml-5"
            @click="$emit('valider')">
            {{$t('recapRecom.libelleBtnAppliquer')}}
          </b-button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import MsgError from '@/components/general/messageErreur';

export default {
  name: 'validation',
  components: {
    MsgError,
  },
  props: {
    msgErrors: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.card-validation {
  width: 400px;
  min-height: 280px;
  position: absolute;
  top: 5rem;
  left: calc(50% - 200px)
}

</style>
